import { SHighlightText } from '@setvi/shared/components';

import { valueToMonetary } from 'pages/products/utils';
import { PricingMode } from 'pages/auto-rfq/store/rfqConfig';
import { Box } from '@material-ui/core';

interface PricingDisplayProps {
  cost?: number | string;
  sell?: number | string;
  search: string;
  rfqToQuoteEnabled: boolean;
  pricingMode?: `${PricingMode}`;
  defaultMarginEnabled?: boolean;
  showEndDot?: boolean;
}

const PricingDisplay = ({
  cost,
  sell,
  search,
  rfqToQuoteEnabled,
  pricingMode,
  defaultMarginEnabled,
  showEndDot
}: PricingDisplayProps) => {
  // If rfqToQuoteEnabled is false, show cost only if it exists
  if (!rfqToQuoteEnabled) {
    if (!cost) return null;

    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4
        }}>
        <SHighlightText
          value={`Cost: ${valueToMonetary(Number(cost))}`}
          searchQuery={search}
          size="sm"
          maxLines={1}
          fontColor="#333D47"
          weight="bold"
        />
        {showEndDot && <>•</>}
      </Box>
    );
  }

  // If rfqToQuoteEnabled is true, apply pricing mode logic
  if (pricingMode === PricingMode.NO_PRICING) {
    return null;
  }

  const costElement = cost ? (
    <SHighlightText
      value={`Cost: ${valueToMonetary(Number(cost) || 0)}`}
      searchQuery={search}
      size="sm"
      maxLines={1}
      fontColor="#333D47"
      weight="bold"
    />
  ) : null;

  const sellElement = sell ? (
    <SHighlightText
      value={`Sell: ${valueToMonetary(Number(sell) || 0)}`}
      searchQuery={search}
      size="sm"
      maxLines={1}
      fontColor="#333D47"
      weight="bold"
    />
  ) : null;

  if (pricingMode === PricingMode.COST_ONLY && !defaultMarginEnabled) {
    return costElement;
  }

  if (
    pricingMode === PricingMode.CUSTOMER_PRICING ||
    (pricingMode === PricingMode.COST_ONLY && defaultMarginEnabled)
  ) {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4
        }}>
        {sellElement}
        {sellElement && <>•</>}
        {costElement}
        {costElement && showEndDot && <>•</>}
      </Box>
    );
  }

  return null;
};

export default PricingDisplay;
